import { ApiEuObjectiveRevenueMetrics, EuTaxonomyRevenueValue } from '@upright/common/model/input/eu-taxonomy/types';
import { MetricNature } from '@upright/common/model/input/types';
import { RequestStatus } from '@upright/ui/api/common/types';
import { useTaxonomyLensContext } from '@upright/ui/common/upright/core/impact-lenses/taxonomy/common/use-taxonomy-lens-context';
import { chain, values } from 'lodash';
import Skeleton from 'react-loading-skeleton';

export function TaxonomyLensSourceDescription() {
  const ctx = useTaxonomyLensContext();
  if (!ctx) {
    return <></>;
  }
  const data = ctx.data;
  if (data.loadingStatus === RequestStatus.LOADING) {
    return <Skeleton width="5.0em" />;
  }
  const kpis = data.taxonomyKpis;
  if (!kpis) {
    return <>Error</>;
  }
  const items = chain(kpis)
    .mapValues(byAct => values(byAct))
    .values()
    .flatten()
    .compact()
    .value();
  return <>{toSourceDescription(items)}</>;
}

function toSourceDescription(data: ApiEuObjectiveRevenueMetrics[]) {
  const eligibilities = data.map(d => d.eligibility).filter((d): d is EuTaxonomyRevenueValue => d !== null);
  const anyDirectDisclosures = eligibilities.find(d => d.nature === MetricNature.DIRECT_DISCLOSURE);
  const anyNonDirectDisclosures = eligibilities.find(d => d.nature !== MetricNature.DIRECT_DISCLOSURE);
  if (anyDirectDisclosures && anyNonDirectDisclosures) {
    return 'Upright net impact model, direct disclosures';
  } else if (anyDirectDisclosures) {
    return 'Data provided by the company';
  } else {
    return 'Upright net impact model';
  }
}
